import { useAtom, useAtomValue, useSetAtom } from "jotai";

import Button from "components/Button";
import Flex from "components/Flex";
import PageLayout from "components/PageLayout";
import Text from "components/Text";

import { useClientTranslation } from "hooks/useClientTranslation";

import { useStyles } from "./styles";
import IbanInput from "components/IbanInput";
import { usePaymentDetailsForm } from "../hooks/usePaymentDetailsForm";
import { usePageRouting } from "hooks/usePageRouting";
import BottomDrawer from "components/BottomDrawer";
import { pageDrawerAtom } from "atoms/pageDrawer";
import { getQuestionAtom } from "atoms/PayeeQuestions/questions";
import SsnInput from "components/SsnInput";
import NameInput from "components/NameInput";
import { clientConfigAtom } from "atoms/clientConfig";

export const Payee = () => {
  const { t } = useClientTranslation();
  const { onTrackAndNext, currentProgressStep } = usePageRouting();
  const {
    speedyPayment,
  } = useAtomValue(clientConfigAtom);
  const { 
    handleSubmit,
    iban,
    ssn,
    name,
    onTypeIban,
    onTypeSsn,
    onTypeName,
    isValidIban,
    isValidSsn,
    isValidName } = usePaymentDetailsForm();
  const toggleDrawer = useSetAtom(pageDrawerAtom);
  const { classes } = useStyles();
  const [isPersonalIban] = useAtom(getQuestionAtom('isPersonalIban'));
  const showOnlyIban = isPersonalIban || !speedyPayment?.questions || speedyPayment?.questions.length === 0 
  const isErrorIban = iban && !isValidIban ? false : true
  const isErrorSsn = ssn && !isValidSsn ? false : true
  const disableFormSubmit = 
    (showOnlyIban && (!isValidIban || !iban)) || 
    (
      !showOnlyIban && 
        (!isValidIban || !isValidSsn || !isValidName || !iban || !ssn || !name)
    )
  return (
    <PageLayout
      as= 'form'
      title={t("speedy_payment.payment_details.header")} 
      dataTestId="Payee"
      onSubmit={handleSubmit(onTrackAndNext({ name: "SpeedyPayment Payee", properties: {} }))}
      currentStep={currentProgressStep}
      bottomButtons={
        <Button disabled={disableFormSubmit} fullWidth type="submit">
          {t("speedy_payment.payment_details.iban_submit")}
        </Button>
      }
      >
      <Flex py={16} px={24} direction="column">
        <Text sizeVariant="md">{t("speedy_payment.payment_details.iban_instruction")}</Text>
        <Button typeVariant="link" className={classes.explanationButton} onClick={toggleDrawer}>
          {t("speedy_payment.payment_details.iban_help.heading")}
        </Button>
        {
          !showOnlyIban && 
          <Flex py={8}>
                      
                      <Flex py={8}>
                        <NameInput
                          name="name"
                          label={t('speedy_payment.payment_details.name.heading')}
                          onChange={onTypeName}
                          isValid={isValidName}
                          {...(name === undefined ? {} : { value: name })}
                        />
                      </Flex>
                      <Flex py={8}>
                        <SsnInput
                          name="ssn"
                          label={t('speedy_payment.payment_details.ssn.heading')}
                          onChange={onTypeSsn}
                          isValid={isErrorSsn}
                          {...(ssn === undefined ? {} : { value: ssn })}
                        />
                      </Flex>
          </Flex>
        }
        <Flex py={8}>
          <IbanInput
            name="iban"
            label={t('speedy_payment.payment_details.iban.heading')}
            onChange={onTypeIban}
            isValid={isErrorIban}
            {...(iban === undefined ? {} : { value: iban })}
          />
        </Flex>
      </Flex>
      <BottomDrawer heading={t("speedy_payment.payment_details.iban_help.heading")}>
        <Text sizeVariant="md">{t("speedy_payment.payment_details.iban_help.description")}</Text>
      </BottomDrawer>
    </PageLayout>
  );
};
